import { Flow } from 'signup-constants/Flow';
import { Step } from '../views/Step';
import { getIsMobile } from '../utils/deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIsChatBotEnabledByLanguage } from './getIsChatBotEnabledByLanguage';
export const shouldShowChatBot = ({
  currentStep,
  shouldShowFeedbackWidget,
  flowKey
}) => {
  const isChatbotEnabledByLanguage = getIsChatBotEnabledByLanguage();
  const allowedFlows = [Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service, Flow.CmsFree, Flow.HubSpotPartners, Flow.HubspotForStartups, Flow.AssetProvider, Flow.ClassroomTraining, Flow.Developers, Flow.CmsDevelopers, Flow.DirectoryListing, Flow.SolutionsProvider, Flow.Trial];
  const feedbackSteps = [Step.CrmExperienceLevel, Step.HubInterest];

  if (feedbackSteps.includes(currentStep) && shouldShowFeedbackWidget) {
    return false;
  }

  return !getIsMobile() && allowedFlows.includes(flowKey) && isChatbotEnabledByLanguage && !SignupEmbedder.isActive();
};